export const fromMinutesToHoursString = (num) => {
  if (Number.isNaN(num) || num === 0) return '';

  const hours = Math.floor(num / 60);
  const minutes = num % 60;

  if (hours === 0) return `${minutes} mins`;
  if (minutes === 0) return `${hours} hr`;
  return `${hours} hr ${minutes} mins`;
};

export const parseTimeToMinutes = (timeString) => {
  const [hours, minutes] = timeString.split(':').map(Number);
  return hours * 60 + minutes;
};

export const formatDuration = (durationString) => fromMinutesToHoursString(parseTimeToMinutes(durationString));

export const formatDurationFromSeconds = (seconds) => {
  if (!seconds) return '';
  const minutes = Math.round(Number(seconds) / 60);
  return fromMinutesToHoursString(minutes);
};
